import { Link } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import StandardLink from '../tools/StandardLink';

import("../styles/home.scss");

function Home() {
  usePageTitle('Home | Dochano');

  return (
    <section id="Home">

      <div id="denverBackdrop">
        <p>Embracing Continued Professional Development</p>
      </div>

      <h2>Deeper Dive</h2>
      <div className="flex">
        <div>
          <img src={require('../assets/AI.png')} alt="AI Robot at computer discussing with live human." />
          <h3>Artificial Intelligence</h3>
          <p>Finding my place as an Engineer in a world increasingly shaped by AI. With our
            increasing desire to make life easier, it is inevitable that engineers will be
            the first to adopt AI technologies. Below is my journey into AI:
          </p>
          <ul>
            <li>AI Books - <Link to="learning">check out the Learning page</Link></li>
            <li>AI Certificates - <Link to="learning#certificates">check out the Certificates section on the Learning page</Link></li>
            <li>Learning Python - <Link to="exploration#python-playground">check out the Python section on Exploration page</Link></li>
          </ul>
        </div>

        <div>
          <img src={require('../assets/code.png')} alt="Screenshot of VSCode" />
          <h3>Browser Extensions</h3>
          <p>As an engineer with a passion for making life easier, find out more about 
            my Job Posting Extractor extension <Link to="extension">here</Link>. Submitted 
            to both Microsoft Edge and Chrome Extension stores for approval.</p>
        </div>
        
        <div>
          <img src={require('../assets/group-discussion.png')} alt="silhouettes of men and women headshot connected together like a network" />
          <h3>Management</h3>
          <p>Using my skills to quickly learn new technologies and the tools that support 
            them positioned me to grow as a manager. See more about my management 
            philosophy and experience <Link to="management">here</Link>. Some areas of 
            focus include:
            <ul>
              <li>Agile Cerimonies - <Link to="RetroTime">see a few Retrospective here</Link></li>
              <li>Documentation</li>
              <li>Analytic Tools</li>
              <li>Jira - Reports, Dashboards, and Ticket strategies</li>
            </ul>
          </p>
        </div>
      </div>

      <div id="Local">
        <img src={require('../assets/denver-buildings.jpg')} alt="Buildings off of Curtis Street in Downtown Denver" />
        <div>
          <h2>Colorado Based</h2>
          <p>I love the Denver Metro Area and am looking for a new role as a Software Engineering Manager. 
            I have over 24 years FinTech experience working for Communify Fincentric. I have valued transparency and empathy as one 
            company evolved through mergers and acquisitions from <StandardLink href="https://www.crunchbase.com/organization/wall-street-on-demand" isNewWindow={true}>Wall Street On Demand to Markit</StandardLink> (6/2010), 
            then to <StandardLink href="https://www.crunchbase.com/organization/ihs-markit" isNewWindow={true}>IHS Markit</StandardLink> (7/2016), 
            to <StandardLink href="https://www.crunchbase.com/organization/s-p-global" isNewWindow={true}>S&P Global</StandardLink> (2/2022), 
            to finally reside at <StandardLink href="https://communify.com/" isNewWindow={true}>Communify Fincentric</StandardLink> (10/2024). 
            Building research sites for the largest financial companies around the world.</p>
        </div>
      </div>

    </section>
  );
}

export default Home;